import React from 'react'
import css from '../../style.module.scss'
import cn from 'classnames'
// import PropTypes from 'prop-types'

// OrderDestination.propTypes = {}

function OrderDestination({
  forWhomToggle,
  citiesSelect,
  nextButton
}) {

  return (
    <div className={css.orderDestination}>
      <div className={css.toggle}>
        <p className={cn("label-2", "dark-grey", css.toggleLabel)}>Я заказываю набор:</p>
        { forWhomToggle }
      </div>

      <div className={css.select}>
        { citiesSelect }
      </div>

      <div className="form-button">
        { nextButton }
      </div>
    </div>
  )
}

export default OrderDestination
